<template>
    <div class="loader" v-if="loader.loading && loader.componentKey === null">
        <div class="absolute flex flex-col justify-center h-32 w-32  rounded-full" style="z-index: 50; top:calc((80vh - 32px)/2); left: calc((100vw - 128px)/2)">
            <img class="self-center h-24 w-24 -mt-3" src="../../assets/loader.svg">
            <div class="self-center text-center text-xs text-blue -mt-3">Loading...</div>
        </div>
        <!-- <div @click="removeLoader" style="position: fixed; display:flex; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0); z-index: 49;"></div> -->
        <div style="position: fixed; display:flex; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0); z-index: 49;"></div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      loader: 'loader/getLoaderData'
    })
  },
  methods: {
    removeLoader: function () {
      this.$store.dispatch('loader/setLoader', {loading: false, componentKey: null})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Loader.vue